import { FC } from 'react';
import { TriangleAlert } from 'lucide-react';

interface ErrorMessageProps {
  errors: string[];
}

export const ErrorMessage: FC<ErrorMessageProps> = ({ errors }: ErrorMessageProps) => {
  return (
    <div className="text-(--danger-D700)! l4! medium h-3 xl:h-6">
      {errors?.map((message) => (
        <div
          key={message}
          className="flex justify-start items-center gap-1 leading-tight text-[10px] lg:text-[12px] xl:text-[14px] h-full"
        >
          <TriangleAlert color="red" className="shrink-0 mt-px h-3 xl:h-6 xl:w-6" />
          <div className="flex items-center">{message}</div>
        </div>
      ))}
    </div>
  );
};
